"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_demi_1 = require("vue-demi");
const __sfc_main = {};
__sfc_main.props = ['imgUrl', 'showImageViewer'];
__sfc_main.setup = (__props, __ctx) => {
    const emit = __ctx.emit;
    // 图片查看器状态
    const scale = (0, vue_demi_1.ref)(1);
    const translateX = (0, vue_demi_1.ref)(0);
    const translateY = (0, vue_demi_1.ref)(0);
    const isDragging = (0, vue_demi_1.ref)(false);
    const startX = (0, vue_demi_1.ref)(0);
    const startY = (0, vue_demi_1.ref)(0);
    const startTranslateX = (0, vue_demi_1.ref)(0);
    const startTranslateY = (0, vue_demi_1.ref)(0);
    // 触摸事件相关
    const touches = (0, vue_demi_1.ref)([]);
    const initialDistance = (0, vue_demi_1.ref)(0);
    const initialScale = (0, vue_demi_1.ref)(1);
    // 计算图片样式
    const imageStyle = (0, vue_demi_1.computed)(() => ({
        transform: `translate(${translateX.value}px, ${translateY.value}px) scale(${scale.value})`,
        transformOrigin: 'center center',
        transition: isDragging.value ? 'none' : 'transform 0.3s ease'
    }));
    // 关闭图片查看器
    const closeImageViewer = () => {
        emit('close');
        document.body.style.overflow = '';
    };
    // 缩放控制
    const zoomIn = () => {
        scale.value = Math.min(scale.value * 1.2, 5);
    };
    const zoomOut = () => {
        scale.value = Math.max(scale.value / 1.2, 0.5);
    };
    const resetZoom = () => {
        scale.value = 1;
        translateX.value = 0;
        translateY.value = 0;
    };
    // 双击缩放
    const handleDoubleClick = e => {
        e.preventDefault();
        if (scale.value > 1) {
            resetZoom();
        }
        else {
            scale.value = 2;
        }
    };
    // 鼠标滚轮缩放
    const handleWheel = e => {
        e.preventDefault();
        const delta = e.deltaY > 0 ? 0.9 : 1.1;
        scale.value = Math.max(0.5, Math.min(5, scale.value * delta));
    };
    // 触摸事件处理
    const handleTouchStart = e => {
        e.preventDefault();
        touches.value = Array.from(e.touches);
        if (touches.value.length === 1) {
            // 单指拖拽
            isDragging.value = true;
            startX.value = touches.value[0].clientX;
            startY.value = touches.value[0].clientY;
            startTranslateX.value = translateX.value;
            startTranslateY.value = translateY.value;
        }
        else if (touches.value.length === 2) {
            // 双指缩放
            const dx = touches.value[0].clientX - touches.value[1].clientX;
            const dy = touches.value[0].clientY - touches.value[1].clientY;
            initialDistance.value = Math.sqrt(dx * dx + dy * dy);
            initialScale.value = scale.value;
        }
    };
    const handleTouchMove = e => {
        e.preventDefault();
        touches.value = Array.from(e.touches);
        if (touches.value.length === 1 && isDragging.value) {
            // 单指拖拽
            const deltaX = touches.value[0].clientX - startX.value;
            const deltaY = touches.value[0].clientY - startY.value;
            translateX.value = startTranslateX.value + deltaX;
            translateY.value = startTranslateY.value + deltaY;
        }
        else if (touches.value.length === 2) {
            // 双指缩放
            const dx = touches.value[0].clientX - touches.value[1].clientX;
            const dy = touches.value[0].clientY - touches.value[1].clientY;
            const distance = Math.sqrt(dx * dx + dy * dy);
            const newScale = distance / initialDistance.value * initialScale.value;
            scale.value = Math.max(0.5, Math.min(5, newScale));
        }
    };
    const handleTouchEnd = e => {
        e.preventDefault();
        isDragging.value = false;
        touches.value = [];
    };
    // 鼠标事件处理
    const handleMouseDown = e => {
        e.preventDefault();
        isDragging.value = true;
        startX.value = e.clientX;
        startY.value = e.clientY;
        startTranslateX.value = translateX.value;
        startTranslateY.value = translateY.value;
    };
    const handleMouseMove = e => {
        if (!isDragging.value) {
            return;
        }
        e.preventDefault();
        const deltaX = e.clientX - startX.value;
        const deltaY = e.clientY - startY.value;
        translateX.value = startTranslateX.value + deltaX;
        translateY.value = startTranslateY.value + deltaY;
    };
    const handleMouseEnd = e => {
        e.preventDefault();
        isDragging.value = false;
    };
    // 键盘事件处理
    const handleKeyDown = e => {
        // if (!showImageViewer.value) {
        //     return;
        // }
        switch (e.key) {
            case 'Escape':
                closeImageViewer();
                break;
            case '+':
            case '=':
                zoomIn();
                break;
            case '-':
                zoomOut();
                break;
            case '0':
                resetZoom();
                break;
            default:
                break;
        }
    };
    const resetImgViewer = () => {
        scale.value = 1;
        translateX.value = 0;
        translateY.value = 0;
        document.body.style.overflow = 'hidden';
    };
    // 生命周期
    (0, vue_demi_1.onMounted)(() => {
        document.addEventListener('keydown', handleKeyDown);
    });
    (0, vue_demi_1.onUnmounted)(() => {
        document.removeEventListener('keydown', handleKeyDown);
        document.body.style.overflow = '';
    });
    return Object.assign({
        imageStyle,
        closeImageViewer,
        handleDoubleClick,
        handleWheel,
        handleTouchStart,
        handleTouchMove,
        handleTouchEnd,
        handleMouseDown,
        handleMouseMove,
        handleMouseEnd
    }, {
        resetImgViewer
    });
};
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,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